const getters = {
  getListAttachments: (state) => {
    return state.listAttachments
  },
  getIsFetching: (state) => {
    return state.isFetching
  },
  getIsUploading: (state) => {
    return state.isUploading
  },
  getIsDownloading: (state) => {
    return state.isDownloading
  }
}

export default getters
